<template>
    <div
        class="magazine-page-preview"
        :class="pageIn.thumb === null && 'no-thumbnail btn-missing-image remove-icon-margin'">
        <img
            v-if="pageIn.thumb !== null"
            :src="pageIn.thumb" />

        <b-button
            class="btn-edit btn-edit-magazine-page"
            v-if="editable"
            variant="primary"
            @click="toEditor">
            {{ $t('common.edit') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-parent-page-page-component',
    props: {
        pageIn: {
            type: Object,
            required: true,
        },
        magazineIn: {
            type: Object,
            required: true,
        },
        editable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            page: this.pageIn,
        };
    },
    methods: {
        toEditor() {
            let parentPageKey = localStorage.getItem('parentPageKey');
            window.location.href = this.routes.magazineParentPageEdit(
                this.magazineIn.id,
                this.magazineIn.uuid,
                parentPageKey,
            );
        },
    },
};
</script>

<style scoped lang="scss">
.magazine-page-preview {
    position: relative;
    border-radius: $border-radius-content;

    img {
        width: 100%;
        height: 100%;
        object-position: center;
        object-fit: cover;
        border-radius: $border-radius-content;
        border: 1px solid #000;
    }

    &.no-thumbnail {
        background-color: $inverse-info;
        color: $white;
        min-height: 350px;

        &:before {
            color: $white;
            opacity: 0.3;
            font-size: 6rem;
            margin-right: 0;
        }
    }
}

.btn-edit-magazine-page {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: map-get($grid-gutter-spacing, 'eight');
    top: map-get($grid-gutter-spacing, 'fifteen');
    right: map-get($grid-gutter-spacing, 'fifteen');
    z-index: 1;
    line-height: 1;
    font-size: $default-font-size;

    &:before {
        font-size: 0.75rem;
        margin-right: 0;
    }
}
</style>
